"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconLeftArrow = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M60.87 31.42H19.59L33 18a3.9 3.9 0 0 0 0-5.5 3.92 3.92 0 0 0-2.76-1.16 3.88 3.88 0 0 0-2.76 1.15L5 35l2.26 2.26a4.44 4.44 0 0 0 .69.68l19.5 19.59a3.9 3.9 0 0 0 2.76 1.15A3.86 3.86 0 0 0 33 57.53 3.9 3.9 0 0 0 33 52L20 38.92h40.87a4 4 0 0 0 4.2-3.76 4 4 0 0 0-4.2-3.74z"
  })),
  height: undefined,
  width: undefined
});
IconLeftArrow.displayName = 'IconLeftArrow';
var _default = IconLeftArrow;
exports["default"] = _default;